import { Pipe, PipeTransform } from '@angular/core';
import { RestaurantService } from 'src/app/core';

@Pipe({ name: 'cpfCnpj' })
export class CpfCnpjPipe implements PipeTransform {

    constructor(private restaurantService: RestaurantService) {}

    transform(value: string): string {
        if (!value) return '';

        const formatCharsRegex = /[.\-\/]/g;
        const cpfRegex = /^\d{11}$/;
        const cnpjAlphanumericRegex = /^[A-Z0-9]{12}\d{2}$/;
        const cnpjNumericRegex = /^\d{14}$/;

        const sanitized = value.replace(formatCharsRegex, '').toUpperCase();

        if (cpfRegex.test(sanitized)) {
            return sanitized.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        }

        if (cnpjAlphanumericRegex.test(sanitized) || cnpjNumericRegex.test(sanitized)) {
            return sanitized.replace(/(.{2})(.{3})(.{3})(.{4})(.{2})/, '$1.$2.$3/$4-$5');
        }

        return value;
    }
}